import {
  createSampleFlashcard,
  sampleImage
} from "@pathwright/blocks-core/src/blocks/flashcards/block-type"
import produce from "immer"

// Request a random picture from the unsplash api
// Once fetched, it returns the url to the static image (used in FlaschardImage)
export const getStaticSampleImage = (imgUrl = sampleImage) =>
  fetch(imgUrl)
    .then((response) => {
      return response.url
    })
    .catch((error) => {
      console.error("Problem loading image: ", error)
    })

export const addFlashcard = (currentFlashcards) => {
  // In case of undefined (should be needed only in dev)
  const flashcards = currentFlashcards ? currentFlashcards.slice() : []

  const newFlashcard = createSampleFlashcard(flashcards.length + 1)
  return updateOrdering(flashcards.concat(newFlashcard))
}

export const removeFlashcard = (currentFlashcards, flashcardIndex) => {
  const nextFlashcards = currentFlashcards.filter((flashcard, i) => {
    return i !== flashcardIndex
  })

  // Always have at least one flash card
  if (!nextFlashcards.length) {
    nextFlashcards.push(createSampleFlashcard(1))
  }

  return updateOrdering(nextFlashcards)
}

export const updateFlashcard = (flashcards, change) => {
  const { cardIndex, sideType, updateType, value } = change

  return updateOrdering(
    flashcards.map((flashcard, i) => {
      if (i === cardIndex)
        return {
          ...flashcard,
          [sideType]: {
            ...flashcard[sideType],
            [updateType]: value
          }
        }
      return flashcard
    })
  )
}

export const updateOrdering = (cards) => {
  return produce(cards, (draft) => {
    draft.forEach((c, i) => {
      c.order = i + 1
    })
  })
}

export const hasLegacyImage = (side) => {
  if (side.type && side.type === "HTML") {
    return true
  }
  return false
}

export const hasLegacyHTML = (side) => {
  if (side.type && side.type === "IMAGE") {
    return true
  }
  return false
}

export const calcFontSizeFromCharacterCount = (html) => {
  // extract text from html: https://stackoverflow.com/questions/28899298/extract-the-text-out-of-html-string-using-javascript/28899585
  const span = document.createElement("span")
  // overflow: hidden is needed to correctly calculate the content height; otherwise, the Quill editor is included in the calculation.
  span.style.overflow = "hidden"
  span.innerHTML = html
  const text = span.textContent || span.innerText

  const MIN_SIZE = 12
  const MAX_SIZE = 24
  const MIN_CHAR_COUNT = 40
  const MAX_CHAR_COUNT = 280

  const count = text.length

  if (count <= MIN_CHAR_COUNT) return MAX_SIZE
  if (count >= MAX_CHAR_COUNT) return MIN_SIZE

  const adjustedCount = count - MIN_CHAR_COUNT
  const range = MAX_CHAR_COUNT - MIN_CHAR_COUNT
  const fontSizeRange = MAX_SIZE - MIN_SIZE

  const fontSize = Math.round(
    MAX_SIZE - adjustedCount / (range / fontSizeRange)
  )

  if (fontSize <= MIN_SIZE) return MIN_SIZE
  if (fontSize >= MAX_SIZE) return MAX_SIZE

  return fontSize
}
